<mat-accordion >
    <mat-expansion-panel *ngFor="let field of formFields; index as fieldI;"
    (opened)="createForm(field)" [formGroup]="fieldForm">
        <mat-expansion-panel-header>
            <mat-panel-title >
                {{field.name}}
            </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-form-field class="full-width">
            <mat-label>Name (уникальное для формы)</mat-label>
            <input matInput formControlName="name" placeholder="Ex. firstname" value="{{field.name}}">
        </mat-form-field>

        <div  formGroupName="schema">
            <mat-form-field class="full-width">
                <mat-label>Заголовок</mat-label>
                <input matInput formControlName="title" placeholder="Вопрос 1" value="{{field.schema.title}}">
            </mat-form-field>
            <mat-form-field class="full-width">
                <mat-label>Описание (вопрос)</mat-label>
                <input matInput  formControlName="description" placeholder="Какой сейчас год?" value="{{field.schema.description}}">
            </mat-form-field>
            <mat-form-field class="full-width">
                <mat-label>Widget поля</mat-label>
                <div formGroupName="widget">
                <mat-select  (selectionChange)="changeWidget()" formControlName="id">
                    <mat-option  value="string">text</mat-option>
                    <mat-option  value="date">date</mat-option>
                    <mat-option  value="checkbox">checkbox</mat-option>
                </mat-select>
                </div>
            </mat-form-field>
        
            <ng-container *ngIf="fieldForm.value.schema.widget.id=='checkbox'" formGroupName="items">
                <input type="hidden" value="array">
                <ng-container *ngIf="FormCheckboxData.controls.length>0">
                    <div formArrayName="oneOf" *ngFor="let item of FormCheckboxData.controls; let j = index">
                        <div formGroupName="{{j}}">
                            <mat-label>Поле {{j+1}}</mat-label><br>
                            <mat-form-field>
                                <mat-label>Имя option</mat-label>
                                <input matInput formControlName="description" value="">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Name option (уникальное для формы)</mat-label>
                                <input matInput formControlName="enum" placeholder="option1" value="">
                            </mat-form-field>
                        </div>
                    </div>
                </ng-container>
                <button mat-button (click)="addCheckboxItem()">Добавить поле</button>
            </ng-container>
            <button mat-button color="primary" (click)="editField(field.id, fieldI, module)">Сохранить поле</button>
            <button mat-button color="warn" (click)="deleteField(field.id, fieldI, module)">Удалить поле</button>
        </div>
    </mat-expansion-panel>
    <mat-expansion-panel [formGroup]="fieldForm" (opened)="fieldForm.reset();">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <button mat-mini-fab color="primary" aria-label="Example icon button with a home icon">
                    <mat-icon>add</mat-icon>
                </button>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-form-field class="full-width">
            <mat-label>Name (уникальное для формы)</mat-label>
            <input matInput formControlName="name" placeholder="Ex. firstname" value="">
        </mat-form-field>
        <div  formGroupName="schema">
            <mat-form-field class="full-width">
                <mat-label>Заголовок</mat-label>
                <input matInput formControlName="title" placeholder="Вопрос 1" value="">
            </mat-form-field>
            <mat-form-field class="full-width">
                <mat-label>Описание (вопрос)</mat-label>
                <input matInput  formControlName="description" placeholder="Какой сейчас год?" value="">
            </mat-form-field>
            <mat-form-field class="full-width">
                <mat-label>Widget поля</mat-label>
                <div formGroupName="widget">
                <mat-select  (selectionChange)="changeWidget()" formControlName="id">
                    <mat-option  value="string">text</mat-option>
                    <mat-option  value="date">date</mat-option>
                    <mat-option  value="checkbox">checkbox</mat-option>
                </mat-select>
                </div>
            </mat-form-field>
            <ng-container *ngIf="fieldForm.value.schema.widget.id=='string'">
                <input type="hidden" formControlName="type" value="string">
            </ng-container>
            <ng-container *ngIf="fieldForm.value.schema.widget.id=='date'">
                <input type="hidden"  formControlName="type" value="string">
            </ng-container>
            <ng-container *ngIf="fieldForm.value.schema.widget.id=='checkbox'" formGroupName="items">
                <input type="hidden"  value="array">
                <ng-container *ngIf="FormCheckboxData.controls.length>0">
                    <div formArrayName="oneOf" *ngFor="let item of FormCheckboxData.controls; let j = index">
                        <div formGroupName="{{j}}">
                            <mat-label>Поле {{j+1}}</mat-label><br>
                            <mat-form-field>
                                <mat-label>Имя option</mat-label>
                                <input matInput formControlName="description" value="">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Name option (уникальное для формы)</mat-label>
                                <input matInput formControlName="enum" placeholder="option1" value="">
                            </mat-form-field>
                        </div>
                    </div>
                </ng-container>
                <button mat-button (click)="addCheckboxItem()">Добавить checkbox</button>
            </ng-container>
            <div>
                <button mat-button (click)="addField(parentId, module)" color="primary">Создать поле</button>
            </div>
        </div>
    </mat-expansion-panel>
</mat-accordion>